import React, {useContext, useEffect, useState, useMemo} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import TablePagination from '../../TablePagination';
import InputFilter from '../../Filters/InputFilter';
// import SelectComponent from "../../Selects/SelectFilter";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import SelectComponent from '../../Selects/SelectComponent';
import SelectComponentConcorrentes from '../../Selects/SelectComponentConcorrentes';

function Concorrentes({
    editarNegocio,
    marcas,
    concorrentes,
    setLinhasConcorrentes,
    linhasConcorrentes,
}) {
    const {t} = useTranslation();

    const rowCount = linhasConcorrentes.length;

    const eliminarLinha = id => {
        const novasLinhas = linhasConcorrentes.filter(
            concorrente => concorrente.id !== id,
        );

        setLinhasConcorrentes(novasLinhas);
    };

    const handleChildChange = (e, id) => {
        console.log(linhasConcorrentes, "linhas");
        const updatedData = [...linhasConcorrentes];
        updatedData[id] = e;
        setLinhasConcorrentes(updatedData);
    };

    const addConcorrente = () => {
        setLinhasConcorrentes(prev => [
            ...prev,
            {
                id: '',
                idLinha: Math.random() * 999999,
                descricao: '',
                valor: 0,
                marca: null,
                modelo: '',
                pontosFortes: '',
                pontosFracos: '',
            },
        ]);
    };

    return (
        <>
            <div>
                <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    {t('concorrente')}
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('marca')}
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('modelo')}
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('montanteConcorrente')}
                                </th>
                                <th scope="col" className="px-4">
                                    {t('pontosFortes')}
                                </th>
                                <th scope="col" className="">
                                    {t('pontosFracos')}
                                </th>
                                <th scope="col" className="px-6 py-3"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {linhasConcorrentes?.map((row, rowIndex) => (
                                <tr
                                    key={rowIndex}
                                    className="bg-white border-b cursor-pointer dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700">
                                    <td className="px-6 py-4">
                                        <SelectComponentConcorrentes
                                            options={concorrentes}
                                            value={
                                                row.descricao
                                                    ? {
                                                          label: row.descricao,
                                                          value: row.valor,
                                                      }
                                                    : ''
                                            }
                                            placeholder={t('concorrente')}
                                            className="block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                                            onChange={e => {
                                                handleChildChange(
                                                    {
                                                        id: e.value,
                                                        idLinha:
                                                            Math.random() *
                                                            999999,
                                                        descricao: e.label,
                                                        valor: 0,
                                                        marca: null,
                                                        modelo: '',
                                                        pontosFortes: '',
                                                        pontosFracos: '',
                                                    },
                                                    rowIndex,
                                                );
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            isDisabled={!editarNegocio}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <SelectComponent
                                            options={marcas}
                                            value={row.marca}
                                            onChange={e => {
                                                row.marca = e;
                                                handleChildChange(
                                                    row,
                                                    rowIndex,
                                                );
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('selecioneOpcao')}
                                            isDisabled={!editarNegocio}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <input
                                            type="text"
                                            value={row.modelo}
                                            placeholder={t('modelo')}
                                            className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700`}
                                            onChange={e => {
                                                row.modelo = e.target.value;
                                                handleChildChange(
                                                    row,
                                                    rowIndex,
                                                );
                                            }}
                                            disabled={!editarNegocio}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <input
                                            type="number"
                                            value={row.valor}
                                            placeholder={t(
                                                'montanteConcorrente',
                                            )}
                                            className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700`}
                                            onChange={e => {
                                                var montante = Object.assign(
                                                    {},
                                                    row,
                                                );
                                                montante.valor = e.target.value;
                                                handleChildChange(
                                                    montante,
                                                    rowIndex,
                                                );
                                            }}
                                            disabled={!editarNegocio}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <input
                                            type="text"
                                            value={row.pontosFortes}
                                            placeholder={t('pontosFortes')}
                                            className="block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                                            onChange={e => {
                                                var pFortes = Object.assign(
                                                    {},
                                                    row,
                                                );
                                                pFortes.pontosFortes =
                                                    e.target.value;
                                                handleChildChange(
                                                    pFortes,
                                                    rowIndex,
                                                );
                                            }}
                                            disabled={!editarNegocio}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <input
                                            type="text"
                                            value={row.pontosFracos}
                                            placeholder={t('pontosFracos')}
                                            className="block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                                            onChange={e => {
                                                var pFracos = Object.assign(
                                                    {},
                                                    row,
                                                );
                                                pFracos.pontosFracos =
                                                    e.target.value;
                                                handleChildChange(
                                                    pFracos,
                                                    rowIndex,
                                                );
                                            }}
                                            disabled={!editarNegocio}
                                        />
                                    </td>
                                    <td className="px-2 py-4">
                                        {rowCount === rowIndex + 1 &&
                                            row.descricao !== '' && (
                                                <button
                                                    className={`mt-2 rounded-full p-1 ${'bg-blue-600'} text-white cursor-pointer`}
                                                    onClick={e => {
                                                        addConcorrente();
                                                        e.stopPropagation();
                                                    }}>
                                                    <AddRoundedIcon />
                                                </button>
                                            )}
                                        {rowCount != rowIndex + 1 && (
                                            <button
                                                className={`mt-2 rounded-full p-1 ${'bg-red-600'} text-white cursor-pointer`}
                                                onClick={e => {
                                                    eliminarLinha(row.id);
                                                    e.preventDefault();
                                                }}>
                                                <DeleteForeverRoundedIcon />
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* <div className="mb-4">
                        {semDados && <NotFound frase={t('semRegistos')} />}
                    </div> */}
                </div>
            </div>
        </>
    );
}

export default Concorrentes;
